export default __webpack_public_path__ + "static/media/Illustracion_universitarios.92486685.png";